/* global L */

Wee.fn.make('productDetail', {
	init: function() {
		var priv = this.$private;

		if ($.get('productDetail')) {
			priv.productDetail();

			priv.bind();
		}
	},

	unload: function() {
		$.set('productDetail', false);

		$.drop('pricing');
	}
}, {
	/**
	 * Binds events for the product detail page.
	 *
	 * @private
	 * @return void
	 */
	bind: function() {
		var scope = this;

		$('ref:slideTab').on('click', function() {
			scope.maps.forEach(function(el) {
				el.invalidateSize();
			});
		});
	},

	/**
	 * Manages all the JS for the product detail pages. This is included on
	 * product pages because of the url structure of product listings.
	 * (IE: /products/category-name and /products/entry-url)
	 *
	 * @private
	 * @return void
	 */
	productDetail: function() {
		var scope = this,
			sliderOne = Wee.fn.easySlide(),
			sliderTwo = Wee.fn.easySlide();

		sliderOne.init({
			elementRef: 'slideContent',
			trackerRef: 'slideTab',
			enableSwipe: false
		});

		sliderTwo.init({
			elementRef: 'sliderImage',
			trackerRef: 'sliderImage',
			arrows: 'arrow'
		});

		$.assets.load({
			root: '/assets',
			files: [
				'/js/lib/vendor/leaflet.min.js',
				'/css/lib/vendor/leaflet.min.css'
			],
			success: function() {
				scope.maps = [];

				scope.renderViewer();

				if ($('ref:topView').length > 0) {
					scope.renderTopView();
				}

				$.screen.map([
					{
						max: 1,
						callback: function() {
							scope.maps.forEach(function(map) {
								setTimeout(function() {
									map.setZoom(0.1);
								}, 250);
							});
						}
					},
					{
						min: 2,
						max: 2,
						callback: function() {
							scope.maps.forEach(function(map) {
								setTimeout(function() {
									map.setZoom(1.4);
								}, 250);
							});
						}
					},
					{
						min: 3,
						callback: function() {
							scope.maps.forEach(function(map) {
								setTimeout(function() {
									map.setZoom(1.8);
								}, 250);
							});
						}
					}
				]);
			}
		});

		this.loadRecentProducts();
		this.storeCurrentProduct();
	},

	/**
	 * Render the large preview image with leaflet.js
	 *
	 * @private
	 * @return void
	 */
	renderViewer: function() {
		// var dimensions = $.get('modelDimensions'),
		// 	map = L.map('js-model-view', {
		// 		minZoom: 0.1,
		// 		maxZoom: 4,
		// 		center: [0, 0],
		// 		zoom: 1,
		// 		scrollWheelZoom: false,
		// 		crs: L.CRS.Simple,
		// 		attributionControl: false,
		// 		panning: false,
		// 		doubleClickZoom: false,
		// 		zoomControl: false
		// 	}),
		// 	southWest = map.unproject([0, dimensions.height], map.getMaxZoom() - 1),
		// 	northEast = map.unproject([dimensions.width, 0], map.getMaxZoom() - 1),
		// 	bounds = new L.LatLngBounds(southWest, northEast);

		// L.imageOverlay(dimensions.url, bounds).addTo(map);

		// map.setMaxBounds(bounds);

		// $.screen.map([
		// 	{
		// 		max: 2,
		// 		callback: function() {
		// 			map.dragging.disable();

		// 			if (map.tap) {
		// 				map.tap.disable();
		// 			}
		// 		}
		// 	}
		// ]);

		// this.maps.push(map);
	},

	/**
	 * Render the top view image with leaflet.js
	 *
	 * @private
	 * @return void
	 */
	renderTopView: function() {
		// var dimensions = $.get('topView'),
		// 	map = L.map('js-top-view', {
		// 		minZoom: 0.2,
		// 		maxZoom: 4,
		// 		center: [0, 0],
		// 		zoom: 1,
		// 		scrollWheelZoom: false,
		// 		crs: L.CRS.Simple,
		// 		attributionControl: false
		// 	}),
		// 	southWest = map.unproject([0, dimensions.height], map.getMaxZoom() - 1),
		// 	northEast = map.unproject([dimensions.width, 0], map.getMaxZoom() - 1),
		// 	bounds = new L.LatLngBounds(southWest, northEast);

		// L.imageOverlay(dimensions.url, bounds).addTo(map);

		// map.setMaxBounds(bounds);

		// $.screen.map([
		// 	{
		// 		max: 2,
		// 		callback: function() {
		// 			map.dragging.disable();

		// 			if (map.tap) {
		// 				map.tap.disable();
		// 			}
		// 		}
		// 	}
		// ]);

		// this.maps.push(map);
	},

	loadRecentProducts: function() {
		var entryIds = JSON.parse(localStorage.getItem('recentProducts')),
			currentId = $('ref:productEntryId').data('value');

		if (entryIds) {
			var indexOfCurrentId = entryIds.indexOf(currentId);

			if (indexOfCurrentId > -1) {
				entryIds.splice(indexOfCurrentId, 1);
			}

			Wee.data.request({
				url: '/ajax/products',
				method: 'post',
				type: 'form',
				data: {
					entryIds: entryIds
				},
				success: function(response) {
					$('ref:recentProducts').html(response);

					$('ref:recentViews').show();
				}
			});
		}
	},

	storeCurrentProduct: function() {
		var currentId = $('ref:productEntryId').data('value'),
			storedIds = JSON.parse(localStorage.getItem('recentProducts')) || [];

		storedIds.indexOf(currentId) === -1 ? storedIds.push(currentId) : storedIds;

		localStorage.setItem('recentProducts', JSON.stringify(storedIds));
	}
});